import React, { useEffect } from "react";
import { Tooltip } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import "./styles.scss";
import { TooltipProps } from "./types";
import { Instance } from "@popperjs/core";

export default function MoreTooltip(props: TooltipProps): React.JSX.Element {
  const [open, setOpen] = React.useState(false);
  const classNameBase = "scd-table-more";

  const componentTooltipProps = {
    classes: {
      dimension: `${classNameBase}-size`,
    },
    placement: props.placement,
    title: props.title,
  };

  useEffect(() => {
    if (props.outerClose) {
      setOpen(false);
      props.onOuterClose();
    }
  }, [props.outerClose, props]);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const addPopperDimension = (popperReference: Instance) => {
    if (popperReference?.state.elements.popper) {
      popperReference.state.elements.popper.className += ` ${componentTooltipProps.classes.dimension}`;
    }
  };

  return (
    <div className={classNameBase}>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          slotProps={{
            popper: {
              disablePortal: false,
              popperRef: addPopperDimension,
            },
          }}
          classes={{
            tooltip: `${classNameBase}-tooltip`,
          }}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          open={open}
          onClick={handleTooltipOpen}
          placement={componentTooltipProps.placement}
          title={componentTooltipProps.title}
        >
          {props.children}
        </Tooltip>
      </ClickAwayListener>
    </div>
  );
}
